import {makeAutoObservable, observable, runInAction} from 'mobx';

import type {NotificationEvent} from '../../../../../api/event';
import type {RenderContract} from '../../NotificationsListItemDumb/types';
import type {AsyncEventDataProvider, EventContextsMap} from '../types';

import {
  emitter,
  WS_RECEIVE_MESSAGE_EVENT,
} from '../../../../../utils/eventEmitter';

export class AsyncEventStore implements AsyncEventDataProvider {
  data: RenderContract;

  constructor(
    public event: NotificationEvent,
    public contexts: EventContextsMap,
    public staticData: RenderContract,
  ) {
    this.data = staticData;

    makeAutoObservable(
      this,
      {
        contexts: observable.ref,
        event: observable.ref,
        staticData: observable.ref,
      },
      {
        autoBind: true,
      },
    );

    this.subscribeToMembershipDeclinedEvent();
  }

  private handleWSMessage(message: any) {
    if (message.event.type === 'membership_declined') {
      const {membership} = this.contexts;

      if (membership?._id === message?.membership?._id) {
        this.unsubscribeFromMembershipDeclinedEvent();

        runInAction(() => {
          this.data = {
            ...this.staticData,
            buttons: [],
          };
        });
      }
    }
  }

  private subscribeToMembershipDeclinedEvent() {
    emitter.on(WS_RECEIVE_MESSAGE_EVENT, this.handleWSMessage);
  }

  private unsubscribeFromMembershipDeclinedEvent() {
    emitter.off(WS_RECEIVE_MESSAGE_EVENT, this.handleWSMessage);
  }
}
